module.exports = __webpack_public_path__ + "f8e5573286341450663b3ca646487e21.ttf";